import { atom } from 'recoil';

export const chargePointConnectorIdState = atom({
  key: 'chargePointConnectorIdState',
  default: '',
});
